import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';

const ConfirmModal = ({ onConfirmClick, onCancelClick, confirmText, showConfirmModal }) => {
  //redux
  const darkMode = useSelector(state => state.darkMode);

  const renderLogo = () => {
    if (darkMode === true) return <img src={require('../../../images/TruKno-Logo-New.svg').default} alt="logo" style={{ maxWidth: "60px" }} className="img-fluid" />;
    if (darkMode === false) return <img src={require('../../../images/TruKno-Logo-New.svg').default} alt="logo" style={{ maxWidth: "60px" }} className="img-fluid" />;
  };

  return (
    <Modal show={showConfirmModal} /* onHide={onModalHide} */ centered className="modal-primary">
      <Modal.Header className="pr-0">
      </Modal.Header>

      <Modal.Body className="pb-0 pr-3">
        <div className="d-flex flex-column justify-content-center align-items-center p-3">
          {renderLogo()}
          <p className='text-center'>{confirmText}</p>

          <div className='d-flex justify-content-center'>
            <Button variant='outline-secondary' onClick={onCancelClick} className="">Cancel</Button>
            <Button variant='danger' onClick={onConfirmClick} className="ml-2">Confirm</Button>
          </div>

        </div>
      </Modal.Body>
    </Modal >

  );
};

export default ConfirmModal;

// <div>
//   {content}
//   <div className="text-center">
//     <Button variant="outline-secondary" size="sm" onClick={onModalHide}>Cancel</Button>
//     <Button className="mx-2" variant={confirmVariant} size="sm" onClick={onConfirm}>{confirmText}</Button>
//   </div>
// </div>
